window.Utils = {
  // 判断是否是function
  isFunction: function (val) {
    return Object.prototype.toString.call(val) === '[object Function]';
  },

  // 判断是否是数组
  isArray: function (val) {
    return Object.prototype.toString.call(val) === '[object Array]';
  },

  // 判断是否是对象
  isObject: function (val) {
    return val !== null && Object.prototype.toString.call(val) === '[object Object]';
  },

  // 拼接Get请求参数
  concatGetRequestParam: function (urlPrefix, orginalParam) {
    let urlParam = urlPrefix;
    for (let item in orginalParam) {
      urlParam += '/' + orginalParam[item];
    }
    return urlParam;
  },

  // 获取Cookie
  getCookie: function (keyName) {
    let reg = new RegExp('(^|;)' + keyName + '=([^;]*)(;|$)');
    let arr = this.trim(document.cookie, 'g').match(reg);
    if (arr) {
      return unescape(arr[2]);
    } else {
      return null;
    }
  },

  // 设置Cookie 1440一天的分钟
  setCookie: function (keyName, keyValue, expireMins = 1440) {
    let date = new Date();
    date.setTime(date.getTime() + expireMins * 60 * 1000);
    document.cookie = keyName + ' = ' + escape(keyValue) + ((expireMins == null) ? '' : '; expires = ' + date.toGMTString());
  },

  // 删除所有Cookie
  delAllCookie: function () {
    let date = new Date();
    // 设置时间
    date.setTime(-1000);
    let data = document.cookie;
    let dataArray = data.split('; ');
    for (let i = 0; i < dataArray.length; i++) {
      let letName = dataArray[i].split('=');
      document.cookie = letName[0] + '=""; expires=' + date.toGMTString();
    }
  },

  // 数字不足n位补0
  prefixInteger: function (num, n) {
    return (Array(n).join(0) + num).slice(-n);
  },

  trim: function (str, is_global) {
    let result;
    result = str.replace(/(^\s+)|(\s+$)/g, '');
    if (is_global.toLowerCase() === 'g') {
      result = result.replace(/\s/g, '');
    }
    return result;
  },

  // 把对象转为FromData
  convertToFormData: function (originalData) {
    let formData = new FormData();
    for (let item in originalData) {
      if (Object.prototype.toString.call(originalData[item]) === '[object Function]') {
        continue;
      }
      if (Object.prototype.toString.call(originalData[item]) === '[object Array]') {
        if (item.toUpperCase().indexOf('ATTACHMENTFILES') >= 0) {
          let fileData = originalData[item];
          for (let subItem in fileData) {
            if (subItem.AttachmentId) {
              continue;
            }
            formData.append(item, fileData[subItem].raw);
          }
        } else {
          let data = originalData[item];
          for (let subItem in data) {
            formData.append(item, data[subItem]);
          }
        }
      } else {
        formData.append(item, originalData[item])
      }
    }
    // console.log(formData.keys());
    return formData;
  },

  // 深拷贝
  clone: function (destination, source) {
    for (let property in destination) {
      if (Object.prototype.toString.call(destination[property]) === '[object Function]') {
        continue;
      }
      if (this.isObject(source[property]) && this.isArray(source[property]) && source[property] !== null && destination[property]) {
        this.clone(destination[property], source[property]);
      } else {
        destination[property] = source[property];
      }
    }
  },

  // 清空数据
  cleanData: function (target) {
    for (let property in target) {
      if (this.isObject(target[property])) {
        this.cleanData(target[property]);
        continue;
      }

      if (this.isFunction(target[property])) {
        continue;
      }

      if (this.isArray(target[property])) {
        target[property] = [];
        continue;
      }

      target[property] = '';
    }
  },

  // 判断是不是null,undefined,'',NAN
  isEmpty(obj) {
    return obj !== undefined && obj !== null && obj !== '' && !isNaN(obj);
  },

  // 将key,value组成的查询参数
  toQueryPair(key, value) {
    if (typeof value === 'undefined') {
      return key;
    }
    return key + '=' + encodeURIComponent(value === null ? '' : String(value));
  },

  // 将对象转换为get请求的查询参数
  toQueryString(obj) {
    let ret = [];
    for (let key in obj) {
      key = encodeURIComponent(key);
      let values = obj[key];
      // 数组
      if (values && values.constructor === Array) {
        let queryValues = [];
        for (let i = 0, len = values.length, value; i < len; i++) {
          value = values[i];
          queryValues.push(this.toQueryPair(key, value));
        }
        ret = ret.concat(queryValues);
      } else {
        // 字符串
        ret.push(this.toQueryPair(key, values));
      }
    }
    return ret.join('&');
  },

  // paraName 等找参数的名称
  GetUrlParam(paraName) {
    let url = document.location.toString();
    let arrObj = url.split('?');

    if (arrObj.length > 1) {
      let arrPara = arrObj[1].split('&');
      let arr;

      for (let i = 0; i < arrPara.length; i++) {
        arr = arrPara[i].split('=');

        if (arr != null && arr[0] === paraName) {
          return arr[1];
        }
      }
      return '';
    } else {
      return '';
    }
  },

  StopPropagation(e) {
    e.stopPropagation();
    return true;
  },

  // 验证字符串是否是数字
  checkNumber(theObj) {
    let reg = /^[0-9]+.?[0-9]*$/;
    if (reg.test(theObj)) {
      return true;
    }
    return false;
  },

  getBase64Image(img) {
    let canvas = document.createElement('canvas');
    canvas.width = img.width;
    canvas.height = img.height;
    let ctx = canvas.getContext('2d');
    ctx.drawImage(img, 0, 0, img.width, img.height);
    let ext = img.src.substring(img.src.lastIndexOf('.') + 1).toLowerCase();
    let dataURL = canvas.toDataURL('image/' + ext);
    return dataURL;
  },

  Print(id_str) {
    let el = document.getElementById(id_str);
    let iframe = document.createElement('IFRAME');
    let doc = null;
    iframe.setAttribute('style', 'position:absolute;width:0px;height:0px;left:-500px;top:-500px;');
    document.body.appendChild(iframe);
    doc = iframe.contentWindow.document;
    // 引入打印的专有CSS样式，根据实际修改
    doc.write("<link rel='stylesheet' type='text/css' href='../static/assets/css/print.css'>");

    doc.write('<div>' + el.innerHTML + '</div>');
    doc.close();
    iframe.contentWindow.focus();
    iframe.contentWindow.addEventListener('load', function () {
      iframe.contentWindow.print();
    });

    if (navigator.userAgent.indexOf('MSIE') > 0) {
      document.body.removeChild(iframe);
    }
  },

  /**
* 时间秒数格式化
* @param s 时间戳（单位：秒）
* @returns {*} 格式化后的时分秒
*/
  secToTime(s) {
    let t;
    if (s > -1) {
      let hour = Math.floor(s / 3600);
      let min = Math.floor(s / 60) % 60;
      let sec = s % 60;
      if (hour < 10) {
        t = '0' + hour + ':';
      } else {
        t = hour + ':';
      }

      if (min < 10) { t += '0'; }
      t += min + ':';
      if (sec < 10) { t += '0'; }
      t += sec.toFixed(2);
    }
    return t;
  },

  checkPhone(val) {
    let phone = val;
    if (!(/^1[23456789]\d{9}$/.test(phone))) {
      return false;
    }
    return true;
  },

  checkEmail(val) {
    if (!(/^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(val))) {
      return false;
    }
    return true;
  },

  checkUscc(val) {
    if (!(/^[A-Z0-9]+$/.test(val))) {
      return false;
    }
    return true;
  },

  // 随机数字
  generateRandomNum(Min, Max) {
    let Range = Max - Min;
    let Rand = Math.random();

    return Math.floor(Min + Math.round(Rand * Range));
  },
  // 随机字符
  generateMixed(n) {
    let chars = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
    let res = '';
    for (let i = 0; i < n; i++) {
      let id = Math.ceil(Math.random() * 35);
      res += chars[id];
    }
    return res;
  },

  getEnterpriseQualifications() {
    return new Promise((resolve, reject) => {
      let xhr = new XMLHttpRequest();
      xhr.overrideMimeType('application/json');
      xhr.open('GET', '/static/assets/json/enterprise_qualification.json', true);
      xhr.send(null);
      xhr.onreadystatechange = () => {
        if (xhr.readyState !== 4) {
          return;
        }
        if (xhr.status === 0 || xhr.status === 200) {
          try {
            let obj = JSON.parse(xhr.responseText);
            resolve(obj);
          } catch (e) {
            reject(e);
          }
        }
      };
    });
  }

}

// 全局定时器
window.Interval = [];



// WEBPACK FOOTER //
// ./src/common/util.js